var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "page-title" }, [_vm._v("ユーザー設定")]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-container" }, [
      _c("div", { staticClass: "settings-nav" }, [
        _c("ul", { staticClass: "settings-nav-list" }, [
          _c("li", { staticClass: "settings-nav-item" }, [
            _c(
              "a",
              {
                staticClass: "settings-nav-link",
                class: { active: _vm.activeSection === "profile" },
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setActiveSection("profile")
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-user" }),
                _vm._v(" プロフィール\n          "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "settings-nav-item" }, [
            _c(
              "a",
              {
                staticClass: "settings-nav-link",
                class: { active: _vm.activeSection === "account" },
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setActiveSection("account")
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-lock" }),
                _vm._v(" パスワード\n          "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "settings-nav-item" }, [
            _c(
              "a",
              {
                staticClass: "settings-nav-link danger",
                class: { active: _vm.activeSection === "deletion" },
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setActiveSection("deletion")
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-trash" }),
                _vm._v(" アカウント削除\n          "),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-content" }, [
        _vm.activeSection === "profile"
          ? _c("div", { staticClass: "settings-section" }, [
              _c("h2", { staticClass: "settings-section-title" }, [
                _vm._v("プロフィール設定"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "avatar-section" }, [
                _c("img", {
                  staticClass: "avatar",
                  attrs: { src: this.image, alt: "アバター" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "avatar-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary",
                      on: {
                        click: function ($event) {
                          return _vm.uploadImage()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-upload" }),
                      _vm._v(" 画像をアップロード\n            "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "imageInput",
                    staticStyle: { display: "none" },
                    attrs: { type: "file" },
                    on: { change: _vm.handleImageUpload },
                  }),
                  _vm._v(" "),
                  this.image
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-danger",
                          on: {
                            click: function ($event) {
                              return _vm.removeImage($event)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-trash-alt" }),
                          _vm._v(" 画像を削除\n            "),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "name" } },
                  [_vm._v("名前")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.name,
                      expression: "form.name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "name" },
                  domProps: { value: _vm.form.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                this.getErrorMessageMap("name")
                  ? _c("p", { staticClass: "form-text text-danger" }, [
                      _vm._v(_vm._s(this.getErrorMessageMap("name"))),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "email" } },
                  [_vm._v("メールアドレス")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.email,
                      expression: "form.email",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "email", id: "email" },
                  domProps: { value: _vm.form.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "email", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                this.getErrorMessageMap("email")
                  ? _c("p", { staticClass: "form-text text-danger" }, [
                      _vm._v(_vm._s(this.getErrorMessageMap("email"))),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.saveProfile },
                  },
                  [
                    _c("i", { staticClass: "fas fa-save" }),
                    _vm._v(" 変更を保存\n          "),
                  ]
                ),
                _vm._v(" "),
                _vm.completeDialog
                  ? _c("div", { staticClass: "text-success" }, [
                      _vm._v("プロフィールが更新されました。"),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm.activeSection === "account"
          ? _c("div", { staticClass: "settings-section" }, [
              _c("h2", { staticClass: "settings-section-title" }, [
                _vm._v("アカウント設定"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-label",
                    attrs: { for: "current-password" },
                  },
                  [_vm._v("現在のパスワード")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.password,
                      expression: "form.password",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "password", id: "current-password" },
                  domProps: { value: _vm.form.password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "password", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                this.errorMessageMap["password"]
                  ? _c("div", { staticClass: "form-text text-danger" }, [
                      _vm._v(_vm._s(this.errorMessageMap["password"])),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "new-password" } },
                  [_vm._v("新しいパスワード")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.newPassword,
                      expression: "form.newPassword",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "password", id: "new-password" },
                  domProps: { value: _vm.form.newPassword },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "newPassword", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-text" }, [
                  _vm._v("8文字以上で、英字・数字・記号を含めてください"),
                ]),
                _vm._v(" "),
                this.errorMessageMap["newPassword"]
                  ? _c("div", { staticClass: "form-text text-danger" }, [
                      _vm._v(_vm._s(this.errorMessageMap["newPassword"])),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-label",
                    attrs: { for: "confirm-password" },
                  },
                  [_vm._v("新しいパスワード（確認）")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.newPasswordConfirmation,
                      expression: "form.newPasswordConfirmation",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "password", id: "confirm-password" },
                  domProps: { value: _vm.form.newPasswordConfirmation },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.form,
                        "newPasswordConfirmation",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                this.errorMessageMap["newPasswordConfirmation"]
                  ? _c("div", { staticClass: "form-text text-danger" }, [
                      _vm._v(
                        _vm._s(this.errorMessageMap["newPasswordConfirmation"])
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.savePassword },
                  },
                  [
                    _c("i", { staticClass: "fas fa-save" }),
                    _vm._v(" パスワードを更新\n          "),
                  ]
                ),
                _vm._v(" "),
                this.errorMessage
                  ? _c("div", { staticClass: "form-text text-danger" }, [
                      _vm._v(_vm._s(this.errorMessage)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.completeDialog
                  ? _c("div", { staticClass: "form-text text-success" }, [
                      _vm._v("パスワードが更新されました。"),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm.activeSection === "notifications"
          ? _c("div", { staticClass: "settings-section" }, [
              _c("h2", { staticClass: "settings-section-title" }, [
                _vm._v("通知設定"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v("アプリ内通知"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-option" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.notifications.courseUpdates,
                          expression: "notifications.courseUpdates",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.notifications.courseUpdates)
                          ? _vm._i(_vm.notifications.courseUpdates, null) > -1
                          : _vm.notifications.courseUpdates,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.notifications.courseUpdates,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "courseUpdates",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "courseUpdates",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.notifications, "courseUpdates", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v("\n              コースの更新情報\n            "),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-option" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.notifications.testReminders,
                          expression: "notifications.testReminders",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.notifications.testReminders)
                          ? _vm._i(_vm.notifications.testReminders, null) > -1
                          : _vm.notifications.testReminders,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.notifications.testReminders,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "testReminders",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "testReminders",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.notifications, "testReminders", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(
                      "\n              テストのリマインダー\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-option" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.notifications.studyReminders,
                          expression: "notifications.studyReminders",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.notifications.studyReminders)
                          ? _vm._i(_vm.notifications.studyReminders, null) > -1
                          : _vm.notifications.studyReminders,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.notifications.studyReminders,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "studyReminders",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "studyReminders",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.notifications, "studyReminders", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v("\n              学習リマインダー\n            "),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-option" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.notifications.achievements,
                          expression: "notifications.achievements",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.notifications.achievements)
                          ? _vm._i(_vm.notifications.achievements, null) > -1
                          : _vm.notifications.achievements,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.notifications.achievements,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "achievements",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "achievements",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.notifications, "achievements", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v("\n              達成報告\n            "),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v("プッシュ通知"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-option" }, [
                  _c("label", { staticClass: "switch" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.notifications.pushEnabled,
                          expression: "notifications.pushEnabled",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.notifications.pushEnabled)
                          ? _vm._i(_vm.notifications.pushEnabled, null) > -1
                          : _vm.notifications.pushEnabled,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.notifications.pushEnabled,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "pushEnabled",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.notifications,
                                  "pushEnabled",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.notifications, "pushEnabled", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "slider" }),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v("プッシュ通知を有効にする"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.saveNotifications },
                  },
                  [
                    _c("i", { staticClass: "fas fa-save" }),
                    _vm._v(" 設定を保存\n          "),
                  ]
                ),
              ]),
            ])
          : _vm.activeSection === "email"
          ? _c("div", { staticClass: "settings-section" }, [
              _c("h2", { staticClass: "settings-section-title" }, [
                _vm._v("メール設定"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v("メール通知"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-option" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailSettings.newsletter,
                          expression: "emailSettings.newsletter",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.emailSettings.newsletter)
                          ? _vm._i(_vm.emailSettings.newsletter, null) > -1
                          : _vm.emailSettings.newsletter,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.emailSettings.newsletter,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.emailSettings,
                                  "newsletter",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.emailSettings,
                                  "newsletter",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.emailSettings, "newsletter", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v("\n              ニュースレター\n            "),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-option" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailSettings.courseUpdates,
                          expression: "emailSettings.courseUpdates",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.emailSettings.courseUpdates)
                          ? _vm._i(_vm.emailSettings.courseUpdates, null) > -1
                          : _vm.emailSettings.courseUpdates,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.emailSettings.courseUpdates,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.emailSettings,
                                  "courseUpdates",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.emailSettings,
                                  "courseUpdates",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.emailSettings, "courseUpdates", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v("\n              コースの更新情報\n            "),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-option" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailSettings.studyReminders,
                          expression: "emailSettings.studyReminders",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.emailSettings.studyReminders)
                          ? _vm._i(_vm.emailSettings.studyReminders, null) > -1
                          : _vm.emailSettings.studyReminders,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.emailSettings.studyReminders,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.emailSettings,
                                  "studyReminders",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.emailSettings,
                                  "studyReminders",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.emailSettings, "studyReminders", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v("\n              学習リマインダー\n            "),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-option" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailSettings.promotions,
                          expression: "emailSettings.promotions",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.emailSettings.promotions)
                          ? _vm._i(_vm.emailSettings.promotions, null) > -1
                          : _vm.emailSettings.promotions,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.emailSettings.promotions,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.emailSettings,
                                  "promotions",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.emailSettings,
                                  "promotions",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.emailSettings, "promotions", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v("\n              プロモーション情報\n            "),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v("メール受信頻度"),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.emailSettings.frequency,
                        expression: "emailSettings.frequency",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.emailSettings,
                          "frequency",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "immediately" } }, [
                      _vm._v("すぐに受信"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "daily" } }, [
                      _vm._v("1日1回のダイジェスト"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "weekly" } }, [
                      _vm._v("週1回のダイジェスト"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.saveEmailSettings },
                  },
                  [
                    _c("i", { staticClass: "fas fa-save" }),
                    _vm._v(" 設定を保存\n          "),
                  ]
                ),
              ]),
            ])
          : _vm.activeSection === "deletion"
          ? _c("div", { staticClass: "settings-section" }, [
              _c("h2", { staticClass: "settings-section-title" }, [
                _vm._v("アカウント削除"),
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-buttons" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-danger",
                      attrs: {
                        to: "/classroom/myprofile/user-account-deletion",
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-trash" }),
                      _vm._v(" アカウント削除手続きへ進む\n          "),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-warning" }, [
      _c("p", [
        _c("i", { staticClass: "fas fa-exclamation-triangle" }),
        _vm._v(
          " 警告: アカウントを削除すると、以下のデータがすべて失われます：\n          "
        ),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("学習履歴やテスト結果")]),
        _vm._v(" "),
        _c("li", [_vm._v("購入したコースへのアクセス権")]),
        _vm._v(" "),
        _c("li", [_vm._v("保存された学習進捗状況")]),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("この操作は取り消すことができません。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }